import { Routes, Route, useLocation } from "react-router-dom"; 
import Navbar from "./Navbar/Navbar";
import Home from "./Home/Home";
import Recipes from "./Recipes/Recipes";
import RecipeDetails from "./Recipedetails/RecipeDetails";
import About from "./About/About";
import Contact from "./Contact/Contact";
import Footer from "./Footer/Footer";
import { useEffect } from "react";
import ReactGA from "react-ga4";

function Router() {
  const location = useLocation(); // ✅ get current route

  useEffect(() => {
    // ✅ send page view on every route change
    ReactGA.send({
      hitType: "pageview",
      page: location.pathname,
    });
  }, [location]);

  return (
    <>
      <Navbar />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/view-recipes" element={<Recipes />} />
        <Route path="/RecipeDetails/:recipe_id" element={<RecipeDetails />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>

      <Footer />
    </>
  );
}

export default Router;